import type {ProductImage as ProductImageType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/product_images.types';
import {
  ProductColorOptionsProps,
  SoldOutInfo,
  mediaTabletAndUp,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {useIsQuickView} from '../QuickView/useIsQuickView';
import {useSizeReminderPopupOpenedState} from '../utils/useSizeReminderPopupOpenedState';

interface SizeReminderPopupProps {
  productImage: ProductImageType | undefined;
  colorOptions: ProductColorOptionsProps['options'] | null;
  className?: string;
  ColorOptionsComponent?: React.ReactNode;
  isInMiniADPDialog?: boolean;
  onSoldOutButtonClick?: VoidFunction;
}

export const SoldOutSection: FC<SizeReminderPopupProps> = ({
  productImage,
  colorOptions,
  className,
  ColorOptionsComponent,
  isInMiniADPDialog,
  onSoldOutButtonClick,
}) => {
  const isQuickView = useIsQuickView();
  const {open} = useSizeReminderPopupOpenedState();

  if (!productImage) {
    return null;
  }
  const condensed = isQuickView || isInMiniADPDialog;
  const onOpen = () => {
    if (onSoldOutButtonClick) {
      onSoldOutButtonClick();
    } else {
      open();
    }
  };

  return (
    <StyledSoldOutInfo
      productImage={productImage}
      colorOptions={colorOptions}
      open={onOpen}
      className={className}
      condensed={condensed}
      ColorOptionsComponent={ColorOptionsComponent}
      $condensed={condensed}
    />
  );
};

const StyledSoldOutInfo = styled(SoldOutInfo)<{
  $condensed: boolean | undefined;
}>`
  padding-bottom: 1.25rem;

  // we apply the @media directly here instead of using tabletAndUpLinaria
  // because the helper function doesn’t work properly with props.
  @media ${mediaTabletAndUp} {
    padding: ${props =>
      props.$condensed ? '0 0 1.25rem 0' : '0.5rem 3.625rem 2rem'};
  }
`;
